import React from 'react';
import { Field, FormikErrors } from 'formik';
import TranslationHelper from '../../../../../helpers/TranslationHelper';
import FieldWrapper from '../../../../common/formikWrappers/FieldWrapper';
import { UserDataFormValues } from '@/app/components/globalDialog/components/UserEditDialog/DataTab/types';

type Props = {
    errors?: FormikErrors<UserDataFormValues>;
};

export const DataTab = ({ errors }: Props) => {
    return (
        <>
            <Field
                fullWidth
                name="data.firstName"
                label={TranslationHelper.translate('First name')}
                component={FieldWrapper}
                required
                error={Boolean(errors?.firstName)}
                helperText={errors?.firstName}
            />
            <Field
                fullWidth
                name="data.lastName"
                label={TranslationHelper.translate('Surname')}
                component={FieldWrapper}
                required
                error={Boolean(errors?.lastName)}
                helperText={errors?.lastName}
            />
            <Field
                fullWidth
                name="data.email"
                label={TranslationHelper.translate('E-mail')}
                component={FieldWrapper}
                required
                error={Boolean(errors?.email)}
                helperText={errors?.email}
            />
        </>
    );
};
